// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
    color: white !important;
    font-size: 14px !important;
    border-radius: 10px !important;
}

.button:hover {
    cursor: pointer !important;
}

.button:disabled {
    cursor: default !important;
}

.button-success {
    background-color: #36AB71 !important;
    border-color: #36AB71 !important;
}

.button-success:hover {
    background-color: #1A8650 !important;
    border-color: #1A8650 !important;
}

.button-success:active {
    background-color: #8EBE43 !important;
    border-color: #8EBE43 !important;
}

.button-success:disabled {
    background-color: #828181 !important;
    border-color: #828181 !important;
}

.button-danger {
    background-color: #E42321 !important;
    border-color: #E42321 !important;
}

.button-danger:hover {
    background-color: #C10200 !important;
    border-color: #C10200 !important;
}

.button-danger:active {
    background-color: #EC735F !important;
    border-color: #EC735F !important;
}

.button-danger:disabled {
    background-color: #828181 !important;
    border-color: #828181 !important;
}

.tab-class {
    font-weight: lighter !important;
    font-size: 23px;
    line-height: 27px;
}

.tab-class.active {
    text-decoration: none !important;
    padding-bottom: 2px;
    border-bottom: 1px solid #FFFFFF;
}

.tab-class:hover {
    color: white;
}

.invalid-feedback {
    position: absolute !important;
}`, "",{"version":3,"sources":["webpack://./assets/stylesheets/default-buttons.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".button {\n    color: white !important;\n    font-size: 14px !important;\n    border-radius: 10px !important;\n}\n\n.button:hover {\n    cursor: pointer !important;\n}\n\n.button:disabled {\n    cursor: default !important;\n}\n\n.button-success {\n    background-color: #36AB71 !important;\n    border-color: #36AB71 !important;\n}\n\n.button-success:hover {\n    background-color: #1A8650 !important;\n    border-color: #1A8650 !important;\n}\n\n.button-success:active {\n    background-color: #8EBE43 !important;\n    border-color: #8EBE43 !important;\n}\n\n.button-success:disabled {\n    background-color: #828181 !important;\n    border-color: #828181 !important;\n}\n\n.button-danger {\n    background-color: #E42321 !important;\n    border-color: #E42321 !important;\n}\n\n.button-danger:hover {\n    background-color: #C10200 !important;\n    border-color: #C10200 !important;\n}\n\n.button-danger:active {\n    background-color: #EC735F !important;\n    border-color: #EC735F !important;\n}\n\n.button-danger:disabled {\n    background-color: #828181 !important;\n    border-color: #828181 !important;\n}\n\n.tab-class {\n    font-weight: lighter !important;\n    font-size: 23px;\n    line-height: 27px;\n}\n\n.tab-class.active {\n    text-decoration: none !important;\n    padding-bottom: 2px;\n    border-bottom: 1px solid #FFFFFF;\n}\n\n.tab-class:hover {\n    color: white;\n}\n\n.invalid-feedback {\n    position: absolute !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
